/**
 * Removes personally identifiable fields from public service-provider records.
 *
 * The public DownloadServiceProviders / DownloadTopServiceProviders endpoints return
 * full provider rows, including contact details. When those rows are passed straight
 * into getStaticProps props they are serialised into __NEXT_DATA__ and become publicly
 * readable in the page source — exposing provider emails, mobile numbers and dates of
 * birth to anyone viewing source or scraping the page.
 *
 * This guard is applied inside the API layer so every caller is protected by default,
 * including pages added in future. Pages should additionally project down to just the
 * fields they render (see utils/trainer-card-projection) to keep payloads small.
 *
 * NOTE: this is a client-side mitigation. The durable fix is for the backend to stop
 * returning these fields on public listing endpoints.
 */

// Fields that must never reach the browser for a public listing.
export const SENSITIVE_SP_FIELDS = [
    'loginUserId',      // the provider's email address
    'mobileNumber',
    'birthDate',
    'userEmail',
    'userMobile',
    'emailNotification',
    'appNotification',
    'autoResponse',
    'penaltyLevel',
    'trustScore',
    'userPrivacySetting'
]

export const stripSensitiveFields = (record) => {
    if (!record || typeof record !== 'object') return record
    const clean = { ...record }
    for (const field of SENSITIVE_SP_FIELDS) {
        delete clean[field]
    }
    return clean
}

export const stripSensitiveFieldsFromList = (list) =>
    Array.isArray(list) ? list.map(stripSensitiveFields) : list
